export interface NameParts {
  first_name?: string | null;
  second_name?: string | null; // optional middle / second given name
  third_name?: string | null; // primary last name
  fourth_name?: string | null; // second last name
}

/**
 * Safely formats a contractor's full name by:
 * - Ignoring null/undefined/empty parts
 * - Trimming whitespace
 * - Collapsing multiple spaces
 * - Returning a fallback if everything is missing
 */
export function formatContractorName(
  parts: NameParts,
  fallback = "Unnamed Contractor"
): string {
  const tokens = [
    parts.first_name,
    parts.second_name,
    parts.third_name,
    parts.fourth_name,
  ]
    .map((p) => (p ?? "").trim())
    .filter((p) => p.length > 0 && p !== "None");

  if (tokens.length === 0) return fallback;
  return tokens.join(" ");
}

/**
 * Example backend-friendly normalization (could be used before sending to API)
 * Converts empty strings to null to avoid ambiguous blanks in persistence.
 */
export function normalizeNameParts(parts: NameParts): Required<NameParts> {
  return {
    first_name: parts.first_name?.trim() || null,
    second_name: parts.second_name?.trim() || null,
    third_name: parts.third_name?.trim() || null,
    fourth_name: parts.fourth_name?.trim() || null,
  };
}
